import React, { useEffect, useState } from "react";
import { LinearProgress } from "Components/Base/Feedback/LinearProgress";
import { Box } from "Components/Base/Layout/Box";

const PROGRESS_BAR_COLOR = "rgba(45,85,40,.8)";

const CardProgress = (props) => {
  const [progressPercent, setProgressPercent] = useState(0);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const { store, personalId, course } = props;
    let percent = 100;

    if (!course.completed) {
      percent = await store.getCourseStatus(personalId, course.courseId);
    }

    setProgressPercent(percent);
    setReady(true);
  };

  return (
    <Box m={1}>
      <LinearProgress
        value={ready ? progressPercent : 0}
        title={`${props.langugageContext("completed2")}: ${ready ? progressPercent : 0}%`}
        colorOverride={PROGRESS_BAR_COLOR}
      />
    </Box>
  );
};

export default CardProgress;
